import React,{ useState,useEffect} from 'react'
import _ from "lodash";
import {
  
  FormDropdown,
  FormField,
  
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";

import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import {add_plan_touser,apply_loan,branch_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";

export default function ApplyLoanForm({selectUser,close_me,loaded_from=""}){
  
    const [branchList, setBranchList] = useState([])
    const  [selectedRow, setSelectedRow] = useState(selectUser)
    const [OpenForm,setOpenForm] = useState(0)
    const [subscription_plans, set_subscription_plans] = useState([])
    const [selected_plan, setSelected_plan] = useState(null)
    const userData = useSelector((state) => state.auth.user);
    const [serviceTypes,setServiceTypes] = useState([])
    const [selectedServiceType, setSelectedServiceType] = useState(null)
    const getMasterData = ()=>{
      let postData = {"categories":["md_service_types","md_subscription_plans"]};
      //values["tenant_id"] = _.get(selectedTenant,"id");
      postMethod(get_master_data,postData).then((res)=>{
        
        if(_.get(res,"result.md_service_types",[])){

          let lst =  _.get(res,"result.md_service_types",[]);
          lst = lst.filter((item)=>item.id!=1)
          setServiceTypes( lst.map((item)=>{ item["label"] =  item["name"];return item}))
          
        }
        if(_.get(res,"result.md_subscription_plans.length",0)>0){ 
          let md_plans =   _.get(res,"result.md_subscription_plans",[]).map((item)=>{
             item["label"] =  item["name"]
             
             return item
           });
           set_subscription_plans(md_plans)
         }

        
        
      })
    }

    const [payment_link, setpayment_link] = useState("");
    const [isSpinner, setIsSpinner] = useState(false);
    const [order_details, setorder_details] = useState(false);
    const handleSubmit = (values) => {
      setIsSpinner(true);
      setIsSpinner(true);
      values["tenant_id"] = _.get(selectedTenant,"id");
      values["customer_id"] = _.get(selectedRow,"id");
      values["user_id"] = _.get(selectedRow,"id");
      
      values["service_type_id"] = _.get(selectedServiceType,"id");
      
        let url = apply_loan
        if(loaded_from=="APPLY_SUBSCRIPTION"){
          values["current_plan_id"] = _.get(selected_plan,"id");
          url = add_plan_touser
        }
        values["tenant_id"] = _.get(selectedTenant,"id");
      postMethod(url,values).then((res)=>{
        showToast("success",_.get(res, "message","Success"))
        setIsSpinner(false);
        if(loaded_from=="APPLY_SUBSCRIPTION" && _.get(res,"result.payment_link")){
          console.log(res)
          setorder_details(_.get(res,"result"))
          setpayment_link(_.get(res,"result.payment_link"))
        }else{
          setOpenForm(0)
         
         close_form()

        }
        
        
      }).catch ((error)=>{
        showToast("error",_.get(error, "message","Something went wrong!"))
        setIsSpinner(false);

      })
    };

    const [selectedTenant, setSelectedTenant ] = useState(()=>{
      if(_.get(userData, "tenant_details",null) !=null){
          return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
      
        
      }else{
        return null
      }
        
    })
    const getBranchList = ()=>{
      let postData = {
        "search_string": "",
        "page": 1,
        "per_page": 100,
        "created_on": "",
        "created_to": "",
        "sort_by": "id",
        "sort_order": "desc",
        "status_ids": []
      }
      postMethod(branch_list,postData).then((res)=>{
        if(_.get(res, "list.length") >0){
          let list = res["list"].map((item)=>{
            item["label"] =  item["name"]
            
            return item
          });
          setBranchList(list);
        }
        
      })

    }

    let formData = {
        email: Yup.string()
          .email("Invalid email address")
          .required("Email is required")
          .min(2, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        first_name: Yup.string()
          .required("First name is required")
          .min(2, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        last_name: Yup.string()
          .required("Last name is required")
          .min(1, "Must be at least 2 characters")
          .max(50, "Must be 50 characters or less"),
        mobile_no: Yup.string()
          .required("Mobile number is required")
          .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
          .min(10, "Must be at least 10 characters")
          .max(15, "Must be 15 characters"),
          service_type_id:  Yup.string()
          .matches(/^[0-9]+$/, "Only numbers are allowed")
        
      }
    let initialValues ={
    first_name: "",
    last_name: "",
    email: "",
    service_type_id: "",
    mobile_no: "",
    tenant_id:_.get(selectedTenant,"name","somthing")

    }
    if(_.get(userData,"role_id") ==1){
    formData["tenant_id"] = Yup.string()
    .required("Branch is required")
    //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
    //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
    }
  
    let loanFormik = useFormik({
      initialValues:initialValues,
      validationSchema: Yup.object(formData),
      onSubmit: handleSubmit,
      validateOnBlur: true,
      validateOnChange: true,
    });
  
    
    
    const setDetails = (row , type)=>{
      
      loanFormik.setFieldValue("email", _.get(row,"email",""))
      loanFormik.setFieldValue("first_name", _.get(row,"first_name",""))
      loanFormik.setFieldValue("last_name", _.get(row,"last_name",""))
      loanFormik.setFieldValue("mobile_no", _.get(row,"mobile_no",""))
      loanFormik.setFieldValue("experience", _.get(row,"experience",""))
      if(_.get(row,"admin_tenant_details",false)){
        setSelectedTenant(row["admin_tenant_details"])
        loanFormik.setFieldValue("tenant_id", _.get(row,"admin_tenant_details.id",""))
      }else if(_.get(row,"tenant_details",false)){
        setSelectedTenant(row["tenant_details"])
        loanFormik.setFieldValue("tenant_id", _.get(row,"tenant_details.id",""))
      }
      setSelectedRow(row);
    }
    useEffect(()=>{
      getMasterData()
      getBranchList()
      
    },[])
    useEffect(()=>{

      setDetails(selectedRow)
    },[selectedRow])
    
    useEffect(()=>{
      if(_.get(userData,"role_id")==5){
        setSelectedRow({...userData})
      }
    },[userData]);
    const close_form = ()=>{
      if(close_me){
        close_me(0)
      }
    }
 return (<Card className="">
            <div className="pt-1">
           
              {payment_link=="" && <> 
              
              <div className="row">
               
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Email"
                    id="email"
                    name="email"
                    type="text"
                    value={selectedRow?.email}
                    onChange={(e) =>
                      loanFormik.setFieldValue("email", e.target.value)
                    }
                    error={loanFormik.touched.email && loanFormik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={loanFormik.handleBlur}
                    focus={true}
                  />
                  {loanFormik.touched.email && <ErrorLabel
                    name="email"
                    formik={loanFormik}
                    message={loanFormik.errors.email}
                  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="First Name"
                    id="first_name"
                    name="first_name"
                    type="text"
                    value={loanFormik.values.first_name}
                    onChange={(e) =>
                      loanFormik.setFieldValue("first_name", e.target.value)
                    }
                    error={loanFormik.touched.first_name && loanFormik.errors.first_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={loanFormik.handleBlur}
                    focus={true}
                  />
                  {loanFormik.touched.first_name && <ErrorLabel
                    name="first_name"
                    formik={loanFormik}
                    message={loanFormik.errors.first_name}
                  />}
                </div>

                <div className="col-md-4 mb-2">
                  <FormField
                    label="Last Name"
                    id="last_name"
                    name="last_name"
                    type="text"
                    value={loanFormik.values.last_name}
                    onChange={(e) =>
                      loanFormik.setFieldValue("last_name", e.target.value)
                    }
                    error={loanFormik.touched.last_name && loanFormik.errors.last_name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={loanFormik.handleBlur}
                    focus={true}
                  />
                  {loanFormik.touched.last_name && <ErrorLabel
                    name="last_name"
                    formik={loanFormik}
                    message={loanFormik.errors.last_name}
                  />}
                </div>
                <div className="col-md-4 mb-2">
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={loanFormik.values.mobile_no}
                    onChange={(e) =>
                      loanFormik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={loanFormik.touched.mobile_no && loanFormik.errors.mobile_no}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={loanFormik.handleBlur}
                    focus={true}
                  />
                  {loanFormik.touched.mobile_no && <ErrorLabel
                    name="mobile_no"
                    formik={loanFormik}
                    message={loanFormik.errors.mobile_no}
                  />}
                </div>
               
               {_.get( userData,"role_id")!=5&& <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="tenant_id"
                    name="tenant_id"
                    label="Select Branch"
                    options={branchList}
                    onChange={(selected) => {
                      setSelectedTenant({...selected})
                      
                      if (selected?.id) {
                        
                        loanFormik.setFieldValue("tenant_id", selected?.id);
                      }
                    }}
                    value={loanFormik?.values?.tenant_id}
                    error={
                      loanFormik.touched.tenant_id && loanFormik.errors.tenant_id
                    }
                    isImportant={_.get(userData,"role_id") ==1}
                    onBlur={loanFormik.handleBlur}
                    disabled={_.get(userData,"role_id") !=1}
                    focus={true}
                  />
                  {loanFormik.touched.tenant_id && <ErrorLabel
                    name="tenant_id"
                    formik={loanFormik}
                    message={loanFormik.errors.tenant_id}
                  />}
                </div>
                }
                
                { _.get( userData,"role_id")==5 && loaded_from=="APPLY_SUBSCRIPTION" && 
          
          <div className="col-md-6 mb-3">
             <FormDropdown
                id="selectedPlan"
                name="selectedPlan"
                label="Select Plan"
                options={subscription_plans}
                onChange={(selected) => {
                 
                  setSelected_plan(selected);
                  loanFormik.setFieldValue("selectedPlan", selected?.id);
                  
                }}
                value={loanFormik.values.selectedPlan}
                error={loanFormik.touched.selectedPlan && loanFormik.errors.selectedPlan}
                onBlur={()=>{loanFormik.handleBlur();
                  
                }}
              />
              {loanFormik.touched.selectedPlan && <ErrorLabel
              name="selectedPlan"
              formik={loanFormik}
              message={loanFormik.errors.selectedPlan}
            />}
            
          </div>
        }
                
                {loaded_from !="APPLY_SUBSCRIPTION" && <div className="col-md-4 mb-2">
                    <FormDropdown
                      id="service"
                      name="service"
                      label="Loan Enquire"
                      options={serviceTypes}
                      onChange={(selected) => {
                        setSelectedServiceType(selected)
                        loanFormik.setFieldValue("service", selected?.id);
                      }}
                      isImportant={true}
                      value={loanFormik.values.service}
                      error={loanFormik.touched.service && loanFormik.errors.service}
                      onBlur={loanFormik.handleBlur}
                      //className={styles.formField}
                    />
                    {loanFormik.touched.service && <ErrorLabel
                      name="service"
                      formik={loanFormik}
                      message={loanFormik.errors.service}
                    />}
                  </div>}
          
                
              </div>
              <div className="row justify-content-end w-100">
              <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
                <CancelButton label="Cancel" onClick={()=>close_form()} className="btn btn-secondary" />
                <PrimaryButton
                  type="submit"
                  onClick={loanFormik.handleSubmit}
                  spinner={isSpinner}
                  label="Apply"
                  disabled={!(loanFormik.dirty && loanFormik.isValid)}
                />
              </div>            
            </div>
         
         </> }

         {payment_link!=""&&<>
         
              <div className="row">
               
                <div className="col-md-12 mb-2">
                  <div className="terms-content scrollable">
                  
                    <p>By subscribing to  {_.get(order_details,"plan_details.name")}</p>
                    <p>Amount :{_.get(order_details,"plan_details.amount")}Rs/-</p>
                    <p>Validity : {_.get(order_details,"plan_details.validity")} Days</p>
                  </div> 
                 
                 </div> 
                  
                
                
              </div>
              <div className="row justify-content-end w-100">
              <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
                <CancelButton label="Cancel" onClick={()=>close_form()} className="btn btn-secondary" />
                <PrimaryButton
                  type="submit"
                  onClick={()=>{
                    window.open(payment_link, '_blank');
                  }}
                  spinner={isSpinner}
                  label="Pay Now" />
              </div>            
            </div>
         </>}


            </div>
          
          </Card>
          )
}